import { defineStore } from 'pinia'
import { useFetch } from '@/modules/core/composables/useFetch'

///////////////////////////////////////////////////////////////////////////////
// Store
///////////////////////////////////////////////////////////////////////////////

export const useDistributionStore = defineStore('investing/distributionStore', () => {
  const markPaymentAsPaid = async (payload: { id: string; paid_date: string }, { slug }: { slug: string }) => {
    await useFetch(`/v4/${slug}/investing/distributions/${payload.id}/mark-payment-as-paid`).post({
      distribution: payload,
    })
  }

  const markPaymentAsUnpaid = async (id: string, { slug }: { slug: string }) => {
    await useFetch(`/v4/${slug}/investing/distributions/${id}/mark-payment-as-unpaid`).post()
  }

  const removeDistribution = async (id: string, { slug }: { slug: string }) => {
    await useFetch(`/v4/${slug}/investing/distributions/${id}/remove`).post()
  }

  return {
    markPaymentAsPaid,
    markPaymentAsUnpaid,
    removeDistribution,
  }
})
